export default __webpack_public_path__ + "static/media/dragndropwhite.a2a35f39.png";